import { Injectable } from '@angular/core';
import { JeevesSalesCartConfigService } from 'gung-standard-jeeves';
import { BaseViewConfigService, CartRow, CartService, ProductAssortmentParentService } from 'gung-standard';
import { ListLayoutMultipleComponent, ListLayout } from 'gung-list';
import { TyloJeevesSalesCartListComponent } from '../components/checkout/sweden/tylo-jeeves-sales-cart-list/tylo-jeeves-sales-cart-list.component';

@Injectable({
  providedIn: 'root'
})
export class TyloJeevesSalesCartConfigService extends JeevesSalesCartConfigService {
  constructor(
    protected cartService: CartService,
    protected baseViewConfigService: BaseViewConfigService,
    protected productAssortmentParentService: ProductAssortmentParentService
    ) {
    super(cartService, baseViewConfigService, productAssortmentParentService);
  }

  getLayouts(): ListLayout<CartRow>[] {
    return [
      {
        getIconClass: () => '',
        getName: () => 'Cart table',
        getListItemComponent: () => TyloJeevesSalesCartListComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent
      }
    ];
  }
}
